import { GetStaticPropsResult } from 'next';
import { APOLLO_STATE_PROP_NAME, createApolloClient } from './createApolloClient';
import { initializeApollo } from './initializeApollo';

export const withApolloProps = async <T>(
  cb: (client: ReturnType<typeof createApolloClient>) => Promise<GetStaticPropsResult<T>>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  const client = initializeApollo();

  const pageProps = await cb(client);
  if ('props' in pageProps) {
    (pageProps.props as Record<string, unknown>)[APOLLO_STATE_PROP_NAME] = client.cache.extract();
  }

  return pageProps;
};
